// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"c46c1868","422":"4f01e54a","786":"1abfcad4","835":"b6eaa706","906":"154c1783","987":"5f19da5e"}[chunkId] + ".chunk.js";
};